import { Badge } from '@components/designSystem/badges/badges'
import useTypedTranslation from '@hooks/useTypedTranslation'

import type { ReactNode } from 'react'

interface BaseBadgeProps { children: ReactNode }

export function RefillBaseBadge({ children }: BaseBadgeProps) {
  return <Badge size='sm' className="bg-todo-action-refill-tertiary ring-todo-action-refill-secondary">{children}</Badge>
}

export function CheckBaseBadge({ children }: BaseBadgeProps) {
  return <Badge size='sm' className="bg-todo-action-check-tertiary ring-todo-action-check-secondary">{children}</Badge>
}

export function ReorderBaseBadge({ children }: BaseBadgeProps) {
  return <Badge size='sm' className="bg-todo-action-reorder-tertiary ring-todo-action-reorder-secondary">{children}</Badge>
}

function DoneBaseBadge({ children }: BaseBadgeProps) {
  return <Badge size='sm' className="bg-todo-done-tertiary ring-todo-done-secondary">{children}</Badge>
}

export function RefillBadge() {
  const { t } = useTypedTranslation()
  return <RefillBaseBadge>{t('todoList.badges.REFILL')}</RefillBaseBadge>
}

export function RefilledBadge() {
  const { t } = useTypedTranslation()
  return <DoneBaseBadge>{t('todoList.badges.REFILLED')}</DoneBaseBadge>
}

export function CheckBadge() {
  const { t } = useTypedTranslation()
  return <CheckBaseBadge>{t('todoList.badges.CHECK')}</CheckBaseBadge>
}

export function CheckedBadge() {
  const { t } = useTypedTranslation()
  return <DoneBaseBadge>{t('todoList.badges.CHECKED')}</DoneBaseBadge>
}

export function ReorderBadge() {
  const { t } = useTypedTranslation()
  return <ReorderBaseBadge>{t('todoList.badges.REORDER')}</ReorderBaseBadge>
}

export function ReorderedBadge() {
  const { t } = useTypedTranslation()
  return <DoneBaseBadge>{t('todoList.badges.REORDERED')}</DoneBaseBadge>
}
